var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Button from '../button/button';
import { ButtonType } from '../button/buttonType';
export default function Confirm(props) {
    var _a, _b;
    var children = [
        props.onConfirm &&
            _jsx(Button, __assign({ onClick: props.onConfirm, className: 'w-[40%]' }, { children: (_a = props.confirmText) !== null && _a !== void 0 ? _a : "Confirm" }), 0),
        _jsx("div", { className: 'w-[10%]' }, 1),
        props.onCancel &&
            _jsx(Button, __assign({ className: 'w-[40%]', onClick: props.onCancel, buttonType: ButtonType.Outlined }, { children: (_b = props.cancelText) !== null && _b !== void 0 ? _b : "Cancel" }), 2)
    ];
    return (_jsx("div", __assign({ className: "flex flex-row justify-evenly w-full ".concat(props.className) }, { children: props.reverse ? children.reverse() : children })));
}
